import {
  ArrowRightAlt,
  Close,
  DoneOutline,
  MonitorOutlined,
  PanoramaPhotosphere,
} from '@mui/icons-material';
import { Box, Grid, Modal } from '@mui/material';
import React, { useState } from 'react';
import { LightBlueButton } from '../../components';
import * as Images from '../../assets';
import { Link } from 'react-router-dom';
import { routesName } from '../../constants/routes-name';
import { useSelector } from 'react-redux';

const TailoredAlertSolution = () => {
  const { user } = useSelector(({ user }) => user);
  const [open, setOpen] = useState(false);
  const handleClose = () => setOpen(false);
  const handleOpen = () => setOpen(true);

  return (
    <div>
      <Grid
        container
        spacing={3}
        className="lg:px-28 md:px-12 sm:px-6 lg:py-28 md:py-12 py-8 flex justify-center"
      >
        <Grid
          item
          lg={4.6}
          md={6}
          xs={12}
          className="flex flex-col items-center"
        >
          <div className="flex flex-col  gap-16">
            <div>
              <div className="text-[var(--dark-blue)] font-bold text-md tracking-[3px] uppercase">
                Customised alert service
              </div>
              <div className="divider" />
            </div>

            <div className="font-bold text-5xl">Features</div>

            <div className="flex flex-col gap-4">
              <div className="flex gap-4">
                <img
                  style={{ height: '40px', width: '40px' }}
                  src={Images.computer}
                />

                <div className="flex flex-col gap-1">
                  <div className="text-md font-bold">
                    User-friendly dashboard and advanced tender search
                  </div>
                  <div className="text-sm leading-[2]">
                    Provides you insight and access to all humanitarian tenders
                    in an easy searchable notice board
                  </div>
                </div>
              </div>

              <div className="flex gap-4">
                <img
                  style={{ height: '40px', width: '40px' }}
                  src={Images.tick}
                />

                <div className="flex flex-col gap-1">
                  <div className="text-md font-bold">
                    Matching tenders and business opportunities
                  </div>
                  <div className="text-sm leading-[2]">
                    Set your alert service to targeted all interesting business
                    opportunity for your company
                  </div>
                </div>
              </div>

              <div className="flex gap-4">
                <img
                  style={{ height: '40px', width: '40px' }}
                  src={Images.brokenCircle}
                />
                <div className="flex flex-col gap-1">
                  <div className="text-md font-bold">
                    Daily email notification
                  </div>
                  <div className="text-sm leading-[2]">
                    Receive a daily tailored email notifications for all new
                    relevant tenders published in our solution
                  </div>
                </div>
              </div>

              <div className="flex gap-4">
                <img
                  style={{ height: '40px', width: '40px' }}
                  src={Images.brokenCircle}
                />

                <div className="flex flex-col gap-1">
                  <div className="text-md font-bold">
                    Supplier directory (
                    <span className="text-blue-500 hover:underline">
                      learn more
                    </span>
                    )
                  </div>
                  <div className="text-sm leading-[2]">
                    Join our supplier directory, Increase your visibility to
                    organisations and get directly invited by our humanitarian
                    buyers through their access to the directory, allowing them
                    to to efficiently identify the most relevant suppliers to
                    invite from the directory and ensure your company stays
                    ahead of the competition.
                  </div>
                </div>
              </div>
            </div>

            <div>
              {
                <Link to={routesName.pricing}>
                  <LightBlueButton size="large" sx={{ fontSize: '12px' }}>
                    Get Started <ArrowRightAlt />
                  </LightBlueButton>
                </Link>
              }
            </div>
          </div>
        </Grid>
        <Grid item lg={4.6} md={6} xs={12}>
          <div
            className="h-full"
            style={{
              backgroundImage: `url('${Images.homePage3}')`,
              backgroundRepeat: 'no-repeat',
              backgroundPosition: 'center',
              backgroundSize: '100% 100%',
              transition:
                'background 0.3s, border 0.3s, border-radius 0.3s, box-shadow 0.3s',
            }}
          >
            {/*  <img src={Images.homePage3} /> */}
          </div>
        </Grid>
      </Grid>
      <Grid
        container
        spacing={5}
        className="lg:px-28 md:px-12 sm:px-6 lg:py-28 md:py-12 py-8 flex justify-center"
      >
        <Grid item lg={4.6} md={6} xs={12}>
          <div
            className="h-full"
            style={{
              backgroundImage: `url('${Images.homePage2}')`,
              backgroundRepeat: 'no-repeat',
              backgroundPosition: 'center',
              backgroundSize: '100% 100%',
              transition:
                'background 0.3s, border 0.3s, border-radius 0.3s, box-shadow 0.3s',
            }}
          >
            {/*  <img src={Images.homePage2} /> */}
          </div>
        </Grid>
        <Grid
          item
          lg={4.6}
          md={6}
          xs={12}
          className="flex flex-col items-center"
        >
          <div className="flex py-8 flex-col gap-8">
            <div>
              <div className="text-[var(--blue)] font-bold text-md tracking-[3px] uppercase">
                Sister company of Global eSourcing Ltd.
              </div>
              <div className="divider-light" />
            </div>

            <div className="font-bold text-5xl">
              Gain access annually to 12.000+ humanitarian tender notices
              globally.
            </div>

            <div className="flex flex-col gap-6">
              <div className="text-sm leading-[2]">
                Aid-LINK is an online Tender Notice Board and Alert Service for
                suppliers in the humanitarian sector or companies who wants to
                access these business opportunities. So if you are you such a
                company, consultant or organisation looking for opportunities to
                supply goods and services to the humanitarian sector, join us…
              </div>
              <div className="text-sm leading-[2]">
                Our sourcing Specialists ensures businesses save time gathering
                tenders globally in the Humanitarian Sector and we also publish
                tenders directly for the organisations. Buyers from
                international NGO’s use our platform to source for goods and
                services. The Tender Notice Board lists the deals exclusive to
                the humanitarian sector and that NGO buyers has made open, or
                available to general public view and participate in. You would
                need to Join or login to get the details and participate in
                these open tenders.
              </div>
              <div className="text-sm leading-[2]">
                Specialists read, assess and categorise every tender published,
                creating an accurate and easily searchable database. Client
                Managers work with companies to create unique business profiles
                in the Supplier Directory and also ensure that companies receive
                customised email alerts based on the companies requirements.
              </div>
              <div className="text-sm leading-[2]">
                We only charge suppliers a small annual membership fee for
                administration of the Tender Notice Board site on Aid-LINK, no
                fees are levied for suppliers participating (or winning) these
                open tenders.
              </div>
            </div>

            <div>
              <Link to={routesName.pricing}>
                <LightBlueButton size="large" sx={{ fontSize: '12px' }}>
                  JOIN AID-LINK
                </LightBlueButton>
              </Link>
            </div>
          </div>
        </Grid>
      </Grid>
    </div>
  );
};

export default TailoredAlertSolution;
